import {
    AJAX_TYPE
} from '../config';
import userUtils from '@/utils/user'
// user service

const prefix = 'user';
export default {

    // 获取requestId
    [`${prefix}RequestId`]: {
        url: `${userUtils.UCUrl}/modules/api/account/common/request/id/get`,
        type: AJAX_TYPE.GET
    },
    // 登录
    [`${prefix}Login`]: {
        url: `${userUtils.UCUrl}/api/user/login`,
        type: AJAX_TYPE.POST
    },
    // 图形验证码
    [`${prefix}CaptchaImage`]: {
        url: `${userUtils.UCUrl}/api/captcha/captchaImage`,
        type: AJAX_TYPE.GET
    },
    // 用户退出
    [`${prefix}Logout`]: {
        url: `${userUtils.UCUrl}/api/user/logout`,
        type: AJAX_TYPE.GET
    },
    // 获取用户信息
    [`${prefix}getLoginInfo`]: {
        url: '/api/user/getLoginInfo',
        type: AJAX_TYPE.GET
    },
    // 修改密码
    [`${prefix}EditUserInfo`]: {
        url: '/api/user/editUserInfo',
        type: AJAX_TYPE.POST
    },


    // web用户登录
    [`${prefix}UmLoginout`]: {
        url: '/web/crm/login/umLoginout',
        type: AJAX_TYPE.GET
    },

    // 添加用户
    [`${prefix}Add`]: {
        url: '/web/user/add',
        type: AJAX_TYPE.POST
    },
    // 修改密码
    [`${prefix}ChangePwd`]: {
        url: '/web/user/changePwd',
        type: AJAX_TYPE.POST
    },
    // 用户删除
    [`${prefix}Delete`]: {
        url: '/web/user/delete/:idCode',
        type: AJAX_TYPE.GET
    },
    // 用户详情
    [`${prefix}Detail`]: {
        url: '/web/user/detail/:idCode',
        type: AJAX_TYPE.GET
    },
    // 用户编辑
    [`${prefix}Edit`]: {
        url: '/web/user/edit',
        type: AJAX_TYPE.POST
    },
    // 忘记密码
    [`${prefix}ForgetPwd`]: {
        url: '/web/user/forgetPwd',
        type: AJAX_TYPE.POST
    },
    // 忘记密码获取短信验证码
    [`${prefix}GetCodeForget`]: {
        url: '/web/user/getCodeForget',
        type: AJAX_TYPE.GET
    },
    // 修改密码获取短信验证码
    [`${prefix}GetCodeModify`]: {
        url: '/web/user/getCodeModify',
        type: AJAX_TYPE.GET
    },
    // 用户列表查询
    [`${prefix}GetList`]: {
        url: '/web/user/getList',
        type: AJAX_TYPE.POST
    },
    // app用户登录
    [`${prefix}LoginForApp`]: {
        url: '/web/user/loginForApp',
        type: AJAX_TYPE.POST
    },
    // web用户登录
    [`${prefix}LoginForWeb`]: {
        url: '/web/user/loginForWeb',
        type: AJAX_TYPE.POST
    },
    
    // web用户退出
    [`${prefix}LogoutWeb`]: {
        url: '/web/user/logoutWeb',
        type: AJAX_TYPE.GET
    },
    // 用户启用关闭:status 0 关闭 1 开启
    [`${prefix}SetStatus`]: {
        url: '/web/user/setStatus/:id',
        type: AJAX_TYPE.GET
    },
    //用户信息
    [`${prefix}Info`]: {
        url: '/web/user/account/info',
        type: AJAX_TYPE.GET
    },




    // web用户登录
    [`${prefix}LoginForCrm`]: {
        url: '/web/crm/login/unifiedLoginForCrm',
        type: AJAX_TYPE.POST
    },

    // 新的用户登录
       [`${prefix}NewLogin`]: {
        url: '/web/crm/login/login',
        type: AJAX_TYPE.POST
    },

    

     // 需要针对注销，做一些清理工作
    [`${prefix}LoginOut`]: {
        url: '/web/crm/login/loginOut',
        type: AJAX_TYPE.GET
    },


    // 短信登录，发送验证码
    [`userLoginSendMSG`]: {
        url: 'api/isx/hdf/sso/getVerifyKaptcha/webTicket',
        type: AJAX_TYPE.POST
    },

    // 短信登录
    [`userCrmPhoneLoginTenant`]: {
        url: '/api/isx/hdf/sso/crmPhoneLoginTenant',
        type: AJAX_TYPE.POST
    },

    // 获取平台logo
    [`userGetUserLogo`]: {
        url: '/api/open/v1/tenant/getTenantInfo',
        type: AJAX_TYPE.GET
    },





}
